import apiClient from "../helpers/ApiClient";

// Settings & Theme
export const getWebsiteSettings = async () => {
  const res = await apiClient.get("/website-builder/settings");
  return res.data;
};

export const updateWebsiteSettings = async (data) => {
  const res = await apiClient.post("/website-builder/settings", data);
  return res.data;
};

// Sections
export const getWebsiteSections = async () => {
  const res = await apiClient.get("/website-builder/sections");
  return res.data;
};

export const saveWebsiteSections = async (sections) => {
  const res = await apiClient.post("/website-builder/sections", { sections });
  return res.data;
};

export const deleteWebsiteSection = async (id) => {
  const res = await apiClient.delete(`/website-builder/sections/${id}`);
  return res.data;
};

// Media Library
export const getWebsiteMedia = async (params = {}) => {
  const res = await apiClient.get("/website-builder/media", { params });
  return res.data;
};

export const addDriveMedia = async (data) => {
  const res = await apiClient.post("/website-builder/media/drive", data);
  return res.data;
};

export const uploadWebsiteMedia = async (formData) => {
  const res = await apiClient.post("/website-builder/media/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateWebsiteMedia = async (id, data) => {
  const res = await apiClient.put(`/website-builder/media/${id}`, data);
  return res.data;
};

export const deleteWebsiteMedia = async (id) => {
  const res = await apiClient.delete(`/website-builder/media/${id}`);
  return res.data;
};

export const linkWebsiteMedia = async (data) => {
  const res = await apiClient.post("/website-builder/media/link", data);
  return res.data;
};

export const unlinkWebsiteMedia = async (linkId) => {
  const res = await apiClient.delete(`/website-builder/media/link/${linkId}`);
  return res.data;
};

// Rooms
export const getWebsiteRooms = async () => {
  const res = await apiClient.get("/website-builder/rooms");
  return res.data;
};

export const updateWebsiteRoom = async (roomTypeId, data) => {
  const res = await apiClient.post(`/website-builder/rooms/${roomTypeId}`, data);
  return res.data;
};

// Content (Amenities, Offers, Events, FAQs, Pages)
export const getWebsiteContent = async (type) => {
  const res = await apiClient.get("/website-builder/content", {
    params: type ? { type } : {},
  });
  return res.data;
};

export const saveWebsiteContent = async (data) => {
  const res = await apiClient.post("/website-builder/content", data);
  return res.data;
};

export const deleteWebsiteContent = async (id) => {
  const res = await apiClient.delete(`/website-builder/content/${id}`);
  return res.data;
};

// SEO & Audit
export const getWebsiteSeo = async () => {
  const res = await apiClient.get("/website-builder/seo");
  return res.data;
};

export const updateWebsiteSeo = async (data) => {
  const res = await apiClient.post("/website-builder/seo", data);
  return res.data;
};

export const getWebsiteSeoAudit = async () => {
  const res = await apiClient.get("/website-builder/seo/audit");
  return res.data;
};

// Redirects
export const getWebsiteRedirects = async () => {
  const res = await apiClient.get("/website-builder/redirects");
  return res.data;
};

export const saveWebsiteRedirect = async (data) => {
  const res = await apiClient.post("/website-builder/redirects", data);
  return res.data;
};

export const deleteWebsiteRedirect = async (id) => {
  const res = await apiClient.delete(`/website-builder/redirects/${id}`);
  return res.data;
};

// Enquiries
export const getWebsiteEnquiries = async () => {
  const res = await apiClient.get("/website-builder/enquiries");
  return res.data;
};

export const updateWebsiteEnquiryStatus = async (id, status) => {
  const res = await apiClient.put(`/website-builder/enquiries/${id}/status`, { status });
  return res.data;
};

// Publish & Revalidate
export const publishWebsite = async () => {
  const res = await apiClient.post("/website-builder/publish");
  return res.data;
};
